var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgFilter = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M1.42732254,3.48429384 C1.01507805,2.99681474 1.36157899,2.25 2,2.25 L22,2.25 C22.638421,2.25 22.9849219,2.99681474 22.5726775,3.48429384 L14.75,12.7346099 L14.75,21 C14.75,21.5575365 14.1632656,21.9201583 13.6645898,21.6708204 L9.6645898,19.6708204 C9.41050178,19.5437764 9.25,19.284079 9.25,19 L9.25,12.7346099 L1.42732254,3.48429384 Z M3.61647775,3.75 L10.5726775,11.9757062 C10.6871756,12.1111003 10.75,12.2826828 10.75,12.46 L10.75,18.5364745 L13.25,19.7864745 L13.25,12.46 C13.25,12.2826828 13.3128244,12.1111003 13.4273225,11.9757062 L20.3835222,3.75 L3.61647775,3.75 Z"
  }));
};
export default SvgFilter;